import { gql } from "@apollo/client";

const ADJUNTAR_ARCHIVOS = gql`
    mutation subirDocumentosCapa($idGestionCapa: Int!, $input: [ArchivoCapaInput!]!){
        subirDocumentosCapa(idGestionCapa: $idGestionCapa, input: $input) {
            success
        }
    }
`;

export default ADJUNTAR_ARCHIVOS;

export const adaptArchivoInput = (archivo) => {
  return {
    contentType: archivo?.contentType,
    titulo: archivo?.titulo,
    archivo: archivo?.archivo,
    extension: archivo?.extension
  };
};

export const adaptArchivosArrayInput = (archivos) => {
  return structuredClone(archivos)?.map((archivo) => {
    return adaptArchivoInput(archivo);
  });
};